import * as React from 'react';
import { Breadcrumb } from '@alifd/next';

import './index.scss';
const {useEffect} = React;

interface ItemArgs {
  hrefObject: {
    url: string
    name: string
  };
}

function BreadcrumbLayout ( props: any ) {
  const { breadCrumb,domainName,i18n } = props;
  if ( !breadCrumb || !breadCrumb.pathList ) return null;

  const localDomain = domainName.toLocaleLowerCase().replace(/\(\D+\)/ig, '').replace(/[\s\\(\)]/ig,'');

  // 增加首页跳转支持
  const breadCrumbList = breadCrumb.pathList.slice(0);
  breadCrumbList.unshift( {
    hrefObject: {
      name: i18n['detail_subscribe.text_breadcrumb_home'],
      remark: "",
      target: i18n['detail_subscribe.text_breadcrumb_home'],
      url: ""
    }
  } );

  const renderBread = ( hrefObject: { name: string,url: string },index: number ) => {
    const { name,url } = hrefObject;
    return <Breadcrumb.Item key={index} link={`//${localDomain}${url}`}>{name}</Breadcrumb.Item>;
  };
  return ( <div className="breadcrumb-layout">
    <Breadcrumb separator="/">
      {breadCrumbList.map( ( item: ItemArgs,index: number ) => renderBread( item?.hrefObject,index ) )}
    </Breadcrumb>
  </div>
  );
}

export default BreadcrumbLayout;
